import type { CardId } from '../../../../model/types.tsx';
import {
	type OptimisticUiMeta,
	type OptimisticUiMetaWithFlag,
	beginOptimisticUiMeta,
	commitOptimisticUiMeta,
	revertOptimisticUiWithFlagMeta,
} from '../../meta/optimistic-ui-meta.tsx';

export const CARD_DELETE_REQUEST = 'state.actions.cards.delete.CARD_DELETE_REQUEST' as const;

type CardDeleteRequestPayload = {
	cardId: CardId;
};

export type CardDeleteRequestAction = {
	type: typeof CARD_DELETE_REQUEST;
	payload: CardDeleteRequestPayload;
	meta: OptimisticUiMeta;
};

export const cardDeleteRequest = (payload: CardDeleteRequestPayload): CardDeleteRequestAction => ({
	type: CARD_DELETE_REQUEST,
	payload,
	meta: {
		...beginOptimisticUiMeta(),
	},
});

export const CARD_DELETE_SUCCESS = 'state.actions.cards.delete.CARD_DELETE_SUCCESS' as const;

export type CardDeleteSuccessAction = {
	type: typeof CARD_DELETE_SUCCESS;
	payload: {
		cardId: CardId;
	};
	meta: OptimisticUiMeta;
};

export const cardDeleteSuccess = (
	cardId: CardId,
	optimisticId: string,
): CardDeleteSuccessAction => ({
	type: CARD_DELETE_SUCCESS,
	payload: { cardId },
	meta: commitOptimisticUiMeta(optimisticId),
});

export const CARD_DELETE_FAILURE = 'state.actions.cards.delete.CARD_DELETE_FAILURE' as const;

export type CardDeleteFailureAction = {
	type: typeof CARD_DELETE_FAILURE;
	payload: {
		cardId: CardId;
	};
	meta: OptimisticUiMetaWithFlag;
};

export const cardDeleteFailure = (
	cardId: CardId,
	optimisticId: string,
): CardDeleteFailureAction => ({
	type: CARD_DELETE_FAILURE,
	payload: { cardId },
	meta: revertOptimisticUiWithFlagMeta(optimisticId),
});

export const CARD_DELETE = 'state.actions.cards.delete.CARD_DELETE' as const;

type CardDeletePayload = {
	cardId: CardId;
};

export type CardDeleteAction = {
	type: typeof CARD_DELETE;
	payload: CardDeletePayload;
};

export const cardDelete = (cardId: CardId): CardDeleteAction => ({
	type: CARD_DELETE,
	payload: {
		cardId,
	},
});

export type Action =
	| CardDeleteRequestAction
	| CardDeleteSuccessAction
	| CardDeleteFailureAction
	| CardDeleteAction;
